"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var downshift_1 = __importDefault(require("downshift"));
var rxjs_1 = require("rxjs");
var core_1 = require("@material-ui/core");
var renderer_1 = require("./renderer");
var IncrementalSearch_1 = require("./IncrementalSearch");
var useStyles = core_1.makeStyles(function (theme) { return ({
    container: {
        flexGrow: 1,
        position: 'relative'
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: 0,
        left: 0,
        right: 0
    },
    chip: {
        margin: theme.spacing() / 2 + "px " + theme.spacing(4) + "px"
    },
    inputRoot: {
        flexWrap: 'wrap'
    },
    inputInput: {
        width: 'auto',
        flexGrow: 1
    },
    divider: {
        height: theme.spacing(2)
    },
    progress: {
        marginTop: -4,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5
    }
}); });
exports.Search = function (_a) {
    var search = _a.search, onSearched = _a.onSearched, onClick = _a.onClick;
    var classes = useStyles();
    // const [inputValue, setValue] = useState('')
    var _b = react_1.default.useState(false), menuIsOpen = _b[0], setMenuIsOpen = _b[1];
    var _c = react_1.default.useState(), submit$ = _c[0], setSubmit$ = _c[1];
    var timer = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        var s = new rxjs_1.Subject();
        // s.next(now())
        setSubmit$(s);
        return function () { return s.unsubscribe(); };
    }, []);
    react_1.default.useEffect(function () {
        return function () {
            if (timer.current) {
                clearTimeout(timer.current);
            }
        };
    }, []);
    // const updateValue = setValue
    var reducer = function (state, changes) {
        // console.log(state, changes)
        switch (changes.type) {
            case downshift_1.default.stateChangeTypes.changeInput:
                var open_1 = !changes.inputValue || changes.inputValue.length < 2 ? false : true;
                setMenuIsOpen(open_1);
                return __assign(__assign({}, changes), { isOpen: open_1 });
            case downshift_1.default.stateChangeTypes.blurInput:
            case downshift_1.default.stateChangeTypes.mouseUp:
                return __assign(__assign({}, changes), { inputValue: state.inputValue, isOpen: state.isOpen });
            default:
                return changes;
        }
    };
    var handleSubmit = react_1.default.useCallback(function (e) {
        e.preventDefault();
        setMenuIsOpen(true);
        setTimeout(function () {
            submit$.next(IncrementalSearch_1.now());
        }, 100);
        // console.log('submit')
    }, [submit$]);
    var handleOuterClick = react_1.default.useCallback(function () {
        if (timer.current !== null) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(function () { return setMenuIsOpen(false); }, 150);
    }, []);
    return (react_1.default.createElement(downshift_1.default, { id: "downshift-simple", isOpen: menuIsOpen, 
        // inputValue={inputValue}
        // onInputValueChange={v => updateValue(v)}
        onOuterClick: handleOuterClick, stateReducer: reducer }, function (_a) {
        var getInputProps = _a.getInputProps, getItemProps = _a.getItemProps, getMenuProps = _a.getMenuProps, highlightedIndex = _a.highlightedIndex, isOpen = _a.isOpen, selectedItem = _a.selectedItem, inputValue = _a.inputValue;
        return (react_1.default.createElement("form", { className: classes.container, onSubmit: handleSubmit },
            renderer_1.renderInput({
                InputProps: getInputProps({
                    placeholder: '質問内容をご入力ください'
                })
            }),
            react_1.default.createElement("div", __assign({}, getMenuProps()), isOpen ? (react_1.default.createElement(IncrementalSearch_1.IncrementalSearch, { inputValue: inputValue || '', "submit$": submit$, search: search, onSearched: onSearched }, function (_a) {
                var data = _a.data;
                // console.log('graphql query result:', client, data, inputValue)
                if (!data || !data.queryFAQ) {
                    return null;
                }
                if (data.queryFAQ.length === 0 && !!inputValue) {
                    return (react_1.default.createElement(core_1.Paper, { className: clsx_1.default('faq-search-result', classes.paper), square: true },
                        react_1.default.createElement(core_1.LinearProgress, { className: classes.progress })));
                }
                var _b = data.queryFAQ, queryFAQ = _b === void 0 ? [] : _b;
                return (react_1.default.createElement(core_1.Paper, { className: clsx_1.default('faq-search-result', classes.paper), square: true }, queryFAQ.map(function (suggestion, index) {
                    return renderer_1.renderSuggestion({
                        suggestion: suggestion,
                        index: index,
                        highlightedIndex: highlightedIndex,
                        selectedItem: selectedItem,
                        itemProps: getItemProps({ item: suggestion.title }),
                        query: inputValue,
                        onClick: onClick
                    });
                })));
            })) : null)));
    }));
};
//# sourceMappingURL=index.js.map